import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import './scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import CommonTable from '../../component/common-table';
import TimeChart from './time-chart';
import moTimeTrend, { changeType } from './store/index';
import Empty from '@comp/empty/index';
import { newRate } from '@tool/index';
import MainTitle from '../../component/main-title';
import Sub from '../../component/sub';
import moEffectPdf from '../../store/index';
import moMenu from '@/page/effect/store/menu';

interface IProps {}
interface IState {}

const TimeTrend = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    type, empty, barData, lineData, labels,
    tableTitle, tableList, overview,
  } = moTimeTrend;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="effect12" className="time-trend_10 box-111 human-common-pdf">
      <MainTitle
        title='时间趋势'
        subtitle={moMenu.industryName}
        bgcolor={Color.primaryColor(0.1)}
        color={Color.primary} />

      <section className="content-1015">
        {!empty ? (
          <section className="content-1030">
            <TimeChart height={400}
              xData={labels}
              barData={barData}
              lineData={lineData} />
          </section>
        ) : <Empty />}
      </section>

      {!isEmpty(overview) && <section className="chart-detail industry-detail">
        <section>注：</section>
        {
          overview?.map((res: any, r: any) => {
            return <section className='item' key={`${r}`}>
              <b />
              <p >
                {res.map((ele: any, e: any) => {
                  return <span className={ele.mark} key={`${e}l`}>
                    {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 1)) : ele.value}
                  </span>;
                })}
              </p>
            </section>;
          })}
      </section>}
    </section>
  );
};

export default observer(TimeTrend);
